import React from 'react';

import Image from '../image/image';

interface CarouselCardProps {
    height?: number;
    id?: number;
    imageUrl?: string;
    isHomepageCarousel?: boolean;
    location?: string;
    path: string;
    postedDate?: string;
    price?: string;
    title?: string;
    width?: number;
}

const CarouselCard = ({
    path,
    imageUrl,
    price,
    title,
    height,
    width,
    location,
    postedDate,
    isHomepageCarousel,
    id
}: CarouselCardProps) => {
    return (
        <>
            <a className="carousel-card" href={path} data-q={`ad-${id}`}>
                <div className="carousel-card-image">
                    <Image
                        src={imageUrl}
                        alt={`image for ${title}`}
                        height={height}
                        shouldSetContainerStyles={!isHomepageCarousel}
                        width={width}
                    />
                    {price && (
                        <div className="carousel-card-price">
                            <h3>{price}</h3>
                        </div>
                    )}
                </div>
                <div className="carousel-card-text">
                    {title && <h4 className="title">{title}</h4>}
                    <div className="loc-date">
                        <p className="location">{location}</p>
                        <p className="date" data-q="listing-adAge">
                            {postedDate}
                        </p>
                    </div>
                </div>
            </a>
        </>
    );
};

CarouselCard.defaultProps = {
    location: '',
    height: 0,
    width: 0,
    id: 0,
    imageUrl: '',
    isHomepageCarousel: false,
    postedDate: '',
    price: '',
    title: '',
};

export default CarouselCard;
